import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { emptyObject } from 'ui-components/default-props/empty';
import Global from '../../store/global-selectors';
import { messages } from './messages';
import style from './style.module.less';

export const ServiceCollectionService = ({ fulfillmentPlanId, className, dataClassName }) => {
  const selectedServiceId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'serviceId',
    }),
  );
  const selectedProviderId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'sellerLabelProviderId',
    }),
  );
  const services = useSelector(Global.selectSellerServices);
  const providers = useSelector(Global.selectSellerLabelProviders);
  const { name } = useMemo(
    () => services.find(({ serviceId }) => serviceId === selectedServiceId?.toString()) ?? emptyObject,
    [selectedServiceId, services],
  );
  const providerName = useMemo(() => {
    const provider = providers.find((prov) => prov.sellerLabelProviderId === selectedProviderId);
    return provider?.name ?? '';
  }, [selectedProviderId, providers]);
  return (
    !!name && (
      <Tooltip>
        <div className={className}>
          <FormattedMessage {...messages.serviceLabel} />
          <div className={classnames(dataClassName, style.truncate)}>
            {name} - {providerName}
          </div>
        </div>
        <TooltipContent>
          <div className={dataClassName}>
            {name} - {providerName}
          </div>
        </TooltipContent>
      </Tooltip>
    )
  );
};

ServiceCollectionService.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  className: PropTypes.string,
  dataClassName: PropTypes.string,
};
